// MarketPositioningQuestion.jsx
import React from "react";
import { Box } from "@mui/material";
import PerlLabelMedium from "../../components/PerlLabelMedium";
import PerlChip from "../../components/PerlChip";

/**
 * MarketPositioningQuestion - Shared question component
 * Used by: F&B (Cookies, Beverages, etc.), BPCH
 *
 * Chip-based selection with dollar sign icons for market positioning tiers
 */
export default function MarketPositioningQuestion({
  value,
  onChange,
  onAutoAdvance, // Auto-advance handler from ChatInterface
  autoAdvanceOnSelect = false, // Enable auto-advance on selection
}) {
  const options = [
    { value: "Economy", label: "Economy", level: 1 },
    { value: "Standard", label: "Standard", level: 2 },
    { value: "Premium", label: "Premium", level: 3 },
    { value: "Luxury", label: "Luxury", level: 4 },
  ];

  const renderMoneyIcons = (level) => {
    return (
      <Box sx={{ display: "flex", gap: 0.25 }}>
        {[1, 2, 3, 4].map((i) => (
          <span
            key={i}
            style={{
              fontSize: "1rem",
              color: i <= level ? "#FFD700" : "#666",
            }}
          >
            $
          </span>
        ))}
      </Box>
    );
  };

  return (
    <>
      <PerlLabelMedium sx={{ mb: 2, display: "block" }}>Select Market Positioning:</PerlLabelMedium>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {options.map((option) => (
          <PerlChip
            key={option.value}
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <span style={{ minWidth: "80px" }}>{option.label}</span>
                {renderMoneyIcons(option.level)}
              </Box>
            }
            selected={value === option.value}
            onClick={() => {
              onChange(option.value);
              if (autoAdvanceOnSelect && onAutoAdvance) {
                onAutoAdvance();
              }
            }}
          />
        ))}
      </Box>
    </>
  );
}
